import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CollaboRoutingModule } from './collabo.routing';
import { CollaboService } from './collabo.service';
import { HeaderComponent } from './header.component';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {MyaccountComponent} from './myaccount.component';
import {CollaboComponent} from './collabo.component';
import {QuotationComponent} from './quotation.component';
import {MessageComponent} from './message.component';
import {ChangePwdComponent} from './changepwd.component'
import {OverviewComponent} from './overview.component';
import { PaymentComponent } from './payment.component';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { ModalModule } from 'ngx-bootstrap/modal';

import { CollapseModule } from 'ngx-bootstrap/collapse';
@NgModule({
    imports: [MatCheckboxModule,CommonModule,ModalModule,CollaboRoutingModule,CdkAccordionModule,FormsModule,ReactiveFormsModule,
        CollapseModule.forRoot()],
    exports: [],
    declarations: [HeaderComponent,MyaccountComponent,CollaboComponent,PaymentComponent,QuotationComponent,MessageComponent,ChangePwdComponent,OverviewComponent],
    providers: [CollaboService],
})
export class CollaboModule { }
